module.exports = __webpack_public_path__ + "media/images/recipes/schouderkarbonade-169d580aeef28207bc622ea3606bd6cb.pdf";